import { trackAction } from "@/lib/sentry";
import { NavLinkGroup, NavLinkGroupsList } from "@/ui";

import { NavLink, useGetNavLinksGroupLabel } from "../NavLink";
import { useNavLinkGroups } from "../NavLink/useNavLinkGroups";

import { Favorites } from "./Favorites";
import { useNavLinksState } from "./useNavLinksState";

export const GroupsList = () => {
  const getNavLinksGroupLabel = useGetNavLinksGroupLabel();
  const navLinkGroups = useNavLinkGroups();
  const { isFavorite, addToFavorites, removeFromFavorites } = useNavLinksState();

  return (
    <NavLinkGroupsList
      allowsMultipleExpanded
      defaultExpandedKeys={["favorites", ...navLinkGroups.map((group) => group.type)]}
    >
      <Favorites />
      {navLinkGroups.map((group) => (
        <NavLinkGroup
          id={group.type}
          key={group.type}
          title={getNavLinksGroupLabel(group.type)}
          actions={[]}
        >
          {group.items.map((item) => (
            <NavLink
              key={item.type}
              item={item}
              actions={[
                {
                  type: "addToFavorites",
                  hidden: isFavorite(item.type),
                  onClick: () => {
                    trackAction("dashboard.sidebar.favorites.add", {
                      navLinkType: item.type,
                    });
                    addToFavorites(item);
                  },
                },
                {
                  type: "removeFromFavorites",
                  onClick: () => {
                    trackAction("dashboard.sidebar.favorites.remove", {
                      navLinkType: item.type,
                    });
                    removeFromFavorites(item);
                  },
                  hidden: !isFavorite(item.type),
                },
              ]}
            />
          ))}
        </NavLinkGroup>
      ))}
    </NavLinkGroupsList>
  );
};
